/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedGeodesistListResponse } from '../types/PaginatedGeodesistList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type GeodesistsListRequest = {} | null | undefined;
export type GeodesistsListResponse = PaginatedGeodesistListResponse;

export type GeodesistsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: has_certification_a
   * schema:
   *   type: boolean
   * ```
   */
  has_certification_a?: boolean;

  /**
   * ```yaml
   * in: query
   * name: has_certification_b
   * schema:
   *   type: boolean
   * ```
   */
  has_certification_b?: boolean;

  /**
   * ```yaml
   * in: query
   * name: has_certification_c
   * schema:
   *   type: boolean
   * ```
   */
  has_certification_c?: boolean;

  /**
   * ```yaml
   * in: query
   * name: is_active
   * schema:
   *   type: boolean
   * ```
   */
  is_active?: boolean;

  /**
   * ```yaml
   * in: query
   * name: note__icontains
   * schema:
   *   type: string
   * ```
   */
  note__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: official_number
   * schema:
   *   type: integer
   * ```
   */
  official_number?: number;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;
};

/**
 * GET /dmx-server/geodesists/
 *
 * ```yaml
 * operationId: geodesists_list
 * tags:
 *   - geodesists
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedGeodesistList'
 *     description: ''
 * ```
 */
export const geodesistsListOperation = (rest?: GeodesistsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/geodesists/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/geodesists/' };
  };

/**
 * GET /dmx-server/geodesists/
 *
 * ```yaml
 * operationId: geodesists_list
 * tags:
 *   - geodesists
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedGeodesistList'
 *     description: ''
 * ```
 */
export const geodesistsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: GeodesistsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedGeodesistListResponse>> => {
  const operation = geodesistsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/geodesists/
 */
export const useGeodesistsListResource = (
  query: GeodesistsListQuery | null,
  useCached?: boolean,
): UseResource<GeodesistsListResponse> => {
  return useResource<GeodesistsListResponse>({
    path: query === null ? null : geodesistsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
